export const globalStyles = {
  '*': {
    borderColor: 'surface.outlineVariant'
  },
  body: {
    h1: {
      fontSize: '2rem',
      fontWeight: 'bold',
      lineHeight: '2.5rem',
      color: 'surface.onSurface'
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      lineHeight: '2rem',
      color: 'surface.onSurface'
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      lineHeight: '1.75rem',
      color: 'surface.onSurface'
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      lineHeight: '1.5rem',
      color: 'surface.onSurface'
    },
    h5: {
      fontSize: '0.875rem',
      fontWeight: 'bold',
      lineHeight: '1.25rem',
      color: 'surface.onSurface'
    },
    h6: {
      fontSize: '0.75rem',
      fontWeight: 'bold',
      lineHeight: '1rem',
      color: 'surface.onSurface'
    }
  }
};
